import { render, staticRenderFns } from "./SearchSimpleCriteria.vue?vue&type=template&id=35970bc0&"
import script from "./SearchSimpleCriteria.vue?vue&type=script&lang=js&"
export * from "./SearchSimpleCriteria.vue?vue&type=script&lang=js&"
import style0 from "./SearchSimpleCriteria.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports